﻿import { DataReportsService } from "@/ServerTypes/Data/DataReportsService";
import { PropertyItem, Decorators, IReadOnly, Widget } from "@serenity-is/corelib";
import { DataReportViewGrid } from "./DataReportViewGrid";

export interface DataReportViewerOptions {
    reportKey: string;
    hideTitle?: boolean;
    hideToolbar?: boolean;
    hideExcelExport?: boolean;
    hideColumnPicker?: boolean;
    hidePager?: boolean;
    hideParams?: boolean;
    hideGrouping?: boolean;
    hideFooter?: boolean;
    autoRun?: boolean;
    processParams?: (params: PropertyItem[], then: ((params: PropertyItem[]) => void)) => void;
}

@Decorators.registerEditor('Matrix.Data.DataReportViewer', [IReadOnly])
@Decorators.element("<div/>")
export class DataReportViewer extends Widget<DataReportViewerOptions> implements IReadOnly {

    private viewGrid: DataReportViewGrid;

    constructor(container: JQuery, opt: DataReportViewerOptions) {
        super(container, opt);

        DataReportsService.GetViewerModel({
            EntityId: this.options.reportKey
        },
            response => {
                if (!response.Entity)
                    return;

                var model = response.Entity;

                var createGrid = () => {

                    var grid = this.viewGrid = new DataReportViewGrid(this.element, {
                        title: model.Title,
                        description: model.Description,
                        reportKey: model.ReportKey,
                        columns: model.Columns,
                        frozenColumns: model.FrozenColumns,
                        expandAllGroups: model.ExpandAllGroups,
                        queryType: model.QueryType,
                        params: model.Parameters,
                        hidePager: this.options.hidePager,
                        hideGrouping: this.options.hideGrouping,
                        hideFooter: this.options.hideFooter
                    });

                    if (this.options.hideTitle) {
                        grid.element.find('.grid-title, .report-description').hide();
                        grid["toolbar"].element.css('margin-top', 0);
                    }

                    if (this.options.hideExcelExport)
                        grid["toolbar"].findButton('export-xlsx-button').hide();

                    if (this.options.hideColumnPicker)
                        grid["toolbar"].findButton('column-picker-button').hide();

                    if (this.options.hideToolbar)
                        grid["toolbar"].element.hide();

                    if (this.options.hideParams ?? true)
                        grid.element.find('.params-form').hide();

                    if (this.options.autoRun ?? true) {
                        grid.element.find('.tool-button.execute-button').hide().click();
                    }
                };

                if (this.options.processParams)
                    this.options.processParams(model.Parameters, params => {
                        model.Parameters = params;
                        createGrid()
                    });
                else
                    createGrid();

            });
    }

    get_readOnly(): boolean {
        return false;
    }

    set_readOnly(value: boolean): void {
    }
}

